import React from "react";
import { MdCheckCircle } from "react-icons/md";
import { IoLogoModelS } from "react-icons/io";

export default function CarInfo({ data }) {
  console.log(data, "aaaaaaaaaaaaaaaaaaaaaaaaaaaaa");
  return (
    <div className="car-details-wrapper">
      <div className="car-details-title">
        <strong>معلومات السيارة</strong>
      </div>
      <div className="car-details-holder">
        <div className="car-info-row">
          <img
            src="https://cdn.syarah.com/syarah/bundles/Make.svg"
            alt="icon"
          />
          <label>الماركة:</label>
          <strong>{data?.CarBrand?.NameLT}</strong>
        </div>
        <div className="car-info-row">
          <img
            src="https://cdn.syarah.com/syarah/bundles/Model.svg"
            alt="icon"
          />
          {/* <IoLogoModelS /> */}
          <label>النوع:</label>
          <strong>{data?.NameLT}</strong>
        </div>
        <div className="car-info-row">
          <img
            src="https://cdn.syarah.com/syarah/bundles/Year.svg"
            alt="icon"
          />
          <label>الموديل:</label>
          <strong>{data?.ProductionYear}</strong>
        </div>
        <div className="car-info-row">
          <img
            src="https://cdn.syarah.com/syarah/bundles/Year.svg"
            alt="icon"
          />
          <label>السعر:</label>
          <strong>{data?.Price}</strong>
        </div>
        <div className="car-info-row">
          <img
            src="https://cdn.syarah.com/syarah/bundles/Year.svg"
            alt="icon"
          />
          <label> عدد الأحصنة:</label>
          <strong>{data?.HorsePowerCount}</strong>
        </div>
        <div className="car-info-row">
          <img
            src="https://cdn.syarah.com/syarah/bundles/Extention.svg"
            alt="icon"
          />
          <label>الفئة:</label>
          <strong>{data?.CarShap?.NameLT}</strong>
        </div>
        {/* <div className="car-info-row">
          <img
            src="https://cdn.syarah.com/syarah/bundles/Exterior Color.svg"
            alt="icon"
          />
          <label>اللون الخارجي:</label>
          <strong>رصاصي</strong>
          <div className="carDetailsSection-module__colorBox"></div>
        </div>
        <div className="car-info-row">
          <img
            src="https://cdn.syarah.com/syarah/bundles/Interior Color.svg"
            alt="icon"
          />
          <label>اللون الداخلي:</label>
          <strong>رمادي</strong>
          <div className="carDetailsSection-module__colorBox"></div>
        </div> */}
        {/* <div className="car-info-row">
          <img
            src="https://cdn.syarah.com/syarah/bundles/Source.svg"
            alt="icon"
          />
          <label>الوارد:</label>
          <strong>سعودي</strong>
        </div> */}
        <div className="car-info-row">
          <img
            src="https://cdn.syarah.com/syarah/bundles/Fuel Type.svg"
            alt="icon"
          />
          <label>نوع الوقود:</label>
          <strong>{data?.CarFuelType?.NameLT}</strong>
        </div>
        <div className="car-info-row">
          <img
            src="https://cdn.syarah.com/syarah/bundles/Gear.svg"
            alt="icon"
          />
          <label>نوع القير:</label>
          <strong>{data?.GearType?.NameLT}</strong>
        </div>
        <div className="car-info-row">
          <img
            src="https://cdn.syarah.com/syarah/bundles/Cylinder.svg"
            alt="icon"
          />
          {/* <BiCylinder /> */}

          <label>عدد السلندرات:</label>
          <strong>{data?.CylinderNumber} سيليندر</strong>
        </div>
        {/* <div className="car-info-row">
          <img
            src="https://cdn.syarah.com/syarah/bundles/Status.svg"
            alt="icon"
          />
          <label>الحالة:</label>
          <strong>مستعملة</strong>
        </div> */}
        <div className="car-info-row">
          <img
            src="https://cdn.syarah.com/syarah/bundles/engine_size.svg"
            alt="icon"
          />
          <label>حجم المحرك:</label>
          <strong>{data?.EngineCapacity}</strong>
        </div>
        {/* <div className="car-info-row">
          <img
            src="https://cdn.syarah.com/syarah/bundles/Drivetrain.svg"
            alt="icon"
          />
          <label>نوع الدفع:</label>
          {data?.PayingOffRearWheelDrive && <strong>دفع امامي</strong>}
        </div> */}
        <div className="car-info-row">
          <img
            src="https://cdn.syarah.com/syarah/bundles/meter1.svg"
            alt="icon"
          />
          <label>السرعة القصوى:</label>
          <strong>{data?.MaxSpeed} كم</strong>
        </div>
        <div className="car-info-row">
          <img
            src="https://cdn.syarah.com/syarah/bundles/meter1.svg"
            alt="icon"
          />
          <label>الممشى:</label>
          <strong>{data?.SpeedsCount} كم</strong>
        </div>
        {/* <div className="car-info-row">
          <img
            src="https://cdn.syarah.com/syarah/bundles/car_key.svg"
            alt="icon"
          />
          <label>عدد مفاتيح السيارة:</label>
          <strong>1</strong>
        </div> */}
      </div>
    </div>
  );
}
